import AppTabs from "@/components/tabs/AppTabs"
import AppTab from "@/components/tabs/AppTab"
import PageHeader from "@/components/PageHeader"
import AppFormCheckbox from "@/components/forms/AppFormCheckbox"
import AppSelect from "@/components/forms/AppSelect"
import AppAutocomplete from "@/components/forms/AppAutocomplete"
import AppTextField from "@/components/forms/AppTextField"
import DialogForm from "@/components/DialogForm"
import AppButton from "@/components/AppButton"
import AppCard from "@/components/AppCard"
import AppDataTable from "@/components/tables/AppDataTable"
import AppLoader from "@/components/AppLoader"
import AppChip from "@/components/AppChip"
import AppSimpleTable from "@/components/tables/AppSimpleTable"
import AppFabButton from "@/components/AppFabButton"
import AppConfirmDialog from "@/components/AppConfirmDialog"
import AppBreadcrumbs from "@/components/AppBreadcrumbs"
import AppTimePicker from "@/components/AppTimePicker"
import AppFormDatePicker from "@/components/forms/AppFormDatePicker"
import AppDatePicker from "@/components/AppDatePicker"
import AppForm from "@/components/AppForm"
import AppMultipleSelect from "@/components/AppMultipleSelect"
import AppFormTimePicker from "@/components/forms/AppFormTimePicker"
import AppFormMultipleSelect from "@/components/forms/AppFormMultipleSelect"
import AppFormSwitch from "@/components/forms/AppFormSwitch"
import AppPageLoader from "@/components/AppPageLoader"
import SwayLoader from "@/components/SwayLoader"

export default {
    install(app, options) {
        app.component('AppTabs', AppTabs)
        app.component('AppTab', AppTab)
        app.component('PageHeader', PageHeader)
        app.component('AppFormCheckbox', AppFormCheckbox)
        app.component('AppSelect', AppSelect)
        app.component('AppAutocomplete', AppAutocomplete)
        app.component('AppTextField', AppTextField)
        app.component('DialogForm', DialogForm)
        app.component('AppBtn', AppButton)
        app.component('AppFabBtn', AppFabButton)
        app.component('AppCard', AppCard)
        app.component('AppDataTable', AppDataTable)
        app.component('AppLoader', AppLoader)
        app.component('AppChip', AppChip)
        app.component('AppSimpleTable', AppSimpleTable)
        app.component('AppFormDatePicker', AppFormDatePicker)
        app.component('AppConfirmDialog', AppConfirmDialog)
        app.component('AppBreadcrumbs', AppBreadcrumbs)
        app.component('AppTimePicker', AppTimePicker)
        app.component('AppDatePicker', AppDatePicker)
        app.component('AppForm', AppForm)
        app.component('AppMultipleSelect', AppMultipleSelect)
        app.component('AppFormTimePicker', AppFormTimePicker)
        app.component('AppFormMultipleSelect', AppFormMultipleSelect)
        app.component('AppFormSwitch', AppFormSwitch)
        app.component('AppPageLoader', AppPageLoader)
        app.component('SwayLoader', SwayLoader)
    }
}
